(function () {
    "use strict";

    angular
        .module("app")
        .service("sessionService", service);

    function service($http, $q, $cookies, $location, productsService, cartService, addressService, ordersService, customersService, certificatesService) {
        const self = this;
        self.newVersionAvailable = false;
        self.isLoaded = false;
        self.isLoggedIn = false;
        self.user = null;
        self.customer = null;
        self.cartTypeCode = null;

        self.allProductsGrouped = [];
        self.allProducts = [];
        self.classifications = [];
        self.productNames = [];
        self.incentives = [];

        self.products = productsService;
        self.cart = cartService;
        self.addresses = addressService;
        self.customers = customersService;
        self.certificates = certificatesService;

        self.refresh = updateCache => self.getCurrentUser(updateCache);


        function mainLoad() {
            return $q.all([
                productsService.getAllGrouped(),
                productsService.getAllClassifications()
            ]).then(([productsGrouped, classifications]) => {
                self.allProductsGrouped = productsGrouped;
                self.allProducts = productsGrouped.reduce((prev, curr) => prev.concat(curr.items), []);
                self.productNames = self.allProducts.reduce((prev, curr) => prev.concat(curr.full_description), []);
                self.classifications = classifications;


                self.incentives = [];
                self.allProducts.forEach(p => {
                    p.incentives.forEach(i => {
                        const existingI = self.incentives.find(si => si.incentive_id === i.incentive_id);
                        if (!existingI) {
                            self.incentives.push({
                                incentive_id: i.incentive_id,
                                incentive_name: i.incentive_name,
                                incentive_description_html: i.incentive_description_html,
                                incentive_type: i.incentive_type,
                                items: [
                                    {
                                        item_id: i.item_id,
                                        item_html: i.item_html,
                                        item_suggest_html: i.item_suggest_html,
                                        discount_amount: i.discount_amount,
                                        sale_UOM_price: p.sale_UOM_price,
                                        full_description: p.full_description,
                                        sale_UOM_desc: p.sale_UOM_desc
                                    }]
                            });
                        } else {
                            if (!existingI.items.some(ei => ei.item_id === i.item_id))
                                existingI.items.push({
                                    item_id: i.item_id,
                                    item_html: i.item_html,
                                    item_suggest_html: i.item_suggest_html,
                                    discount_amount: i.discount_amount,
                                    sale_UOM_price: p.sale_UOM_price,
                                    full_description: p.full_description,
                                    sale_UOM_desc: p.sale_UOM_desc
                                });
                        }
                    });
                });

                // Check out this hack!  LOL
                const inhalationClassification = classifications.find(c => c.class_id === 6);
                if (inhalationClassification) {
                    const inhalationGroup = self.allProductsGrouped.find(g => g.display_group_id === 4);
                    if (inhalationGroup)
                        inhalationGroup.add_header_html = inhalationClassification.add_header_html;
                }


                //console.log("session.allProductsGrouped", self.allProductsGrouped);
                //console.log("session.allProducts", self.allProducts);
                //console.log("session.productNames", self.productNames);
                //console.log("session.classifications", self.classifications);
                //console.log("session.incentives", self.incentives);
                //console.log("session.customer", self.customer);
            });
        }

        self.filteredProducts = () => {
            if (!productsService.searchCriteria.searchText.length)
                return self.allProductsGrouped;

            return [
                {
                    display_group: `Search Results for `,
                    display_group_id: 1,
                    items: self.allProducts
                }
            ];
        };


        let currentUserPromise;
        self.getCurrentUser = updateCache => {
            if (!currentUserPromise || updateCache)
                currentUserPromise =
                    $http.get("/api/users/current")
                        .then(result => {
                            const user = result.data;

                            if (user == null || !self.customer || self.customer.customer_id != user.customer_id)
                                return self.setUser(user).then(() => user);

                            if (!self.cartTypeCode || self.cartTypeCode != user.cart_type_code)
                                return self.setCartType(user.cart_type_code).then(() => user);

                            return $q.resolve(user);
                        })
                        .catch(err => {
                            currentUserPromise = null; // make sure next call to getCurrentUser() isn't getting a cached failure
                            return $q.reject(err);
                        });

            return currentUserPromise;
        }

        self.setUser = user => {
            let customer = null;

            if (user) {
                self.user = user;
                const customerId = user.customer_id;

                if (customerId)
                    customer = self.user.customers.find(c => c.customer_id === customerId);

                if (!customer && self.user.customers.length === 1)
                    customer = self.user.customers[0];
            } else {
                $cookies.remove("stcart");
                self.user = null;
            }

            return self.setCustomer(customer, user.cart_type_code);
        }

        self.setCustomer = (customer, cartTypeCode) => {
            const customerId = customer ? customer.customer_id : null;
            const req = {
                company_id: customerId // insert emoji of banging head on desk
            };
            return $http
                .post("/api/security/session-company", req)
                .then(() => {
                    if (customerId) {
                        self.customer = customer;
                        mainLoad();

                        addressService.refresh(customerId); // dont think we need to wait on this.
                        certificatesService.refresh(); // dont think we need to wait on this.
                        return self.setCartType(cartTypeCode || self.cartTypeCode);
                    } else {
                        self.customer = null;
                        return self.setCartType(null);
                    }
                });
        };

        self.setCartType = cartTypeCode => {
            productsService.clear();
            productsService.isSearching = true; // keeps the search ui clean when changing customers.
            cartService.clear();
            ordersService.clear();

            const req = {
                cart_type_code: cartTypeCode
            };
            return $http
                .post("/api/security/session-cart-type", req)
                .then(() => {
                    if (cartTypeCode) {
                        self.cartTypeCode = cartTypeCode;
                        return $q.all([
                            productsService.refresh(),
                            cartService.refresh()
                        ]).then(() => {
                            self.isLoggedIn = true;
                        });
                    } else {
                        self.isLoggedIn = false;
                        self.cartTypeCode = null;
                    }
                });
        }

        self.logOut = () => {
            return $http
                .post("/api/security/logout")
                .then(() => self.refresh(true));
        };

        self.login = request => {
            return $http
                .post("/api/security/login", request)
                .then(result => {
                    if (result.data.logged_in) {
                        $cookies.put("stcart", result.data.token);
                        return self.refresh(true).then(() => result.data);
                    }
                    return result.data;
                });
        };

        self.gotoProductSearch = () => {
            const path = `/product-search/${cleanSearchText(productsService.searchCriteria.searchText)}/`;
            $location.path(path);
        };

        self.gotoCart = () => {
            const path = `cart/`;
            $location.path(path);
        };

        self.backToSearchResults = () => {
            if (productsService.searchCriteria.searchText) {
                self.gotoProductSearch();
            } else if (productsService.searchCriteria.classId) {
                $location.path(`/product-class/${productsService.searchCriteria.classId}`);
            } else {
                $location.path("/");
            }
        };

        function cleanSearchText(value) {
            // get rid of / . @
            return value.replace(/[\\\/.@#]/g, "");
        }
    }
    service.$inject = ["$http", "$q", "$cookies", "$location", "productsService", "cartService", "addressService", "ordersService", "customersService", "certificatesService"];

})()